// прожектс

import React, { useState } from "react";
import styled, { css } from "styled-components";
import { useTheme } from "../context/ThemeContext";

// --- Base
const projects = [
  //   {
  //     name: "Todo App",
  //     icon: "./icons/todo.svg",
  //     iconDark: "./icons/todo-d.svg",
  //     link: "https://ezizovb.github.io/todo",
  //     description:
  //       "Простой менеджер задач. Это один из первых моих самостоятельных проектов, выполненный сразу после освоения манипуляций с DOM и обработки событий в чистом JavaScript.",
  //     back: "./images/task.jpg",
  //     buttonLabel: "Посмотреть Проект",
  //   },
  {
    name: "Project_A",
    icon: "./icons/projectA.png",
    iconDark: "./icons/projectA-d.png",
    link: "https://ezizovb.github.io/project_a",
    description:
      "Project_A представляет собой интерактивный инструмент-справочник для методов JavaScript, охватывающий ключевые области: Array, Object и DOM-манипуляции. В архитектуре проекта реализованы событийно-управляемые взаимодействия (event-driven), оптимизированное использование DOM и чистая логика, которую обеспечивает внешний источник данных в формате JSON.",
    back: "./images/projA.jpg",
    buttonLabel: "Посмотреть Проект",
  },
  {
    name: "_CV",
    icon: "./icons/pcv.png",
    iconDark: "./icons/pcv-d.png",
    link: "https://ezizovb.github.io/_cv",
    description:
      "Это мой более ранний CV-сайт, полностью разработанный мной. Его ключевые особенности: переключатель тёмной/светлой темы, поддержка трёх языков, динамическое приветствие, модальные окна для предпросмотра изображений (активируются иконками в заголовке) и динамические фоновые эффекты, реализованные на Canvas.",
    back: "./images/cvv.jpg",
    buttonLabel: "Посмотреть Проект",
  },
  {
    name: "EduPoint",
    icon: "./icons/eduLogo.png",
    iconDark: "./icons/eduLogo-d.png",
    link: "https://github.com/ezizovb/edupointinfo",
    description:
      "Цифровая платформа для эффективной и прозрачной проверки знаний. Для преподавателей это единый инструмент для быстрого создания тестов и анализа прогресса студентов. Студенты получают удобный доступ к заданиям и видят полную картину своей академической успеваемости. EduPoint упрощает и делает контроль знаний понятным для всех. (В данный момент работа бэкенда временно затруднена из-за особенностей регионального доступа.) <a href='https://github.com/ezizovb/scholl_tests' target='_blank' rel='noopener noreferrer'><Посмотреть Код></a>",
    back: "./images/edu.png",
    buttonLabel: "Подробно",
    // titleAttribute: "временные технические проблемы с деплоем серверной части",
  },
  {
    name: "Martin Lion",
    icon: "./icons/martinlion.svg",
    iconDark: "./icons/martinlion_d.png",
    link: "https://ezizovb.github.io/martinlion",
    description:
      "Интернет-магазин парфюмерии, принимающий заказы без серверного бэкенда. Форма заказа отправляет данные напрямую на почту магазина с помощью EmailJS. Реализован удобный интерфейс, логика оформления заказа и адаптивная верстка. Проект демонстрирует, как можно обрабатывать заказы на статическом сайте.",
    back: "./images/martinlion_back.png",
    buttonLabel: "Посмотреть Проект",
  },
];

const SectionProjects = styled.section`
  padding: 50px 20px;
  background-color: rgba(255, 255, 255, 0.75);
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
  font-family: Arial, sans-serif;

  body.dark-theme & {
    background-color: rgba(26, 26, 26, 0.75); /* темный полупрозрачный фон */
  }

  @media (max-width: 640px) {
    padding: 50px 10px;
  }
`;

const MaxWidthWrapper = styled.div`
  max-width: 900px;
  margin-left: auto;
  margin-right: auto;
  padding-left: 20px;
  padding-right: 20px;
  @media (max-width: 500px) {
    padding-left: 10px;
    padding-right: 10px;
  }
`;

const Title = styled.h3`
  font-size: 2rem;
  font-family: Philosopher;
  font-weight: 700;
  margin-bottom: 2.25rem;
  text-align: center;
  color: var(--color-text);
`;

const CardContainer = styled.div`
  display: grid;
  /* НОВОЕ ПРАВИЛО: default на широких экранах (>= 900px) 2 колонки */
  grid-template-columns: repeat(2, 1fr);
  gap: 1.5rem;
  justify-content: center;

  @media (max-width: 900px) {
    /* if ширина карточки меньше 250px, переключиться на 1 колонку */
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  }

  @media (max-width: 640px) {
    /* на мобильных (уже меньше 640px): 1 колонка */
    grid-template-columns: 1fr;
  }
`;

const Card = styled.div.attrs((props) => ({
  title: props.$title,
}))`
  padding: 20px;
  border-radius: 15px;
  min-height: 300px;
  transition: all 0.7s ease;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
  overflow: hidden;
  z-index: 1;

  background-color: white;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);

  body.dark-theme & {
    background-color: rgba(42, 42, 42, 0.9);
    box-shadow: 0 4px 6px rgba(255, 255, 255, 0.05);
  }

  /* ::before: размытый фон (изоб) */
  &::before {
    content: "";
    position: absolute;
    inset: 0;
    background-image: url(${(props) => props.$backImage});
    background-size: cover;
    background-position: center;
    filter: blur(4px);
    z-index: -2;
    opacity: 0;
    transition:
      opacity 0.7s ease,
      filter 0.7s ease;
  }

  /* ::after: Оверлей (Слой, который скрывает ::before) */
  &::after {
    content: "";
    position: absolute;
    inset: 0;
    z-index: -1;
    opacity: 1; /* изначально полностью непрозрачен (скрывает ::before) */
    background-color: white; /* Цвет светлой темы */
    transition:
      background-color 0.7s ease,
      opacity 0.7s ease;
  }

  /* дарк ТЕМА для оверлея */
  body.dark-theme &::after {
    /* Используем цвет самой карточки, чтобы оверлей был незаметен */
    background-color: rgba(42, 42, 42, 0.98);
  }

  /* эфект при наведении */
  &:hover {
    box-shadow: 0 8px 15px rgba(0, 0, 0, 0.3);
    transform: scale(1.02);
    color: #151417;
  }

  /* При наведении: ПЛАААВНО показываем ::before */
  &:hover::before {
    filter: blur(2px);
    opacity: 1;
  }

  /* При наведении: ПЛААВНО УДАЛЯЕМ ::after */
  &:hover::after {
    opacity: 0; /*пПлавное исчезновение оверлея, показывая изображение */
  }

  /* ФИКСх ХОВЕРА ИНВЕРСИИ */
  body.dark-theme &:hover::before {
    filter: blur(2px) invert(85%) hue-rotate(180deg);
  }

  /* Стили для иконок */
  & img {
    width: 48px;
    height: 48px;
    object-fit: contain;
    margin-bottom: 0.5rem;
    filter: none !important;
  }
`;

const Name = styled.h4`
  font-weight: 700;
  font-size: 1.4rem;
  margin-bottom: 0.5rem;
  color: var(--color-text);
  @media (max-width: 640px) {
    font-size: 1.7rem;
  }
`;

const Description = styled.p`
  font-weight: 400;
  color: var(--color-text);
  flex-grow: 1;
  margin-bottom: 1rem;
  font-family: "Monserat";
  font-size: 1.2rem;

  & a {
    color: #246a32;
    text-decoration: none;
    font-weight: 500;
  }
  body.dark-theme & a {
    color: #38c838ff;
  }
  @media (max-width: 640px) {
    font-size: 1rem;
  }
`;

const Link = styled.a`
  text-align: center;
  padding: 10px 25px;
  font-size: 1rem;
  cursor: pointer;
  background: transparent;

  border: 1px solid #246a32;
  color: #246a32;

  border-radius: 20px;
  transition: all 0.5s ease;
  text-decoration: none;
  font-weight: 500;
  margin-top: 1rem;

  /* ТЕМНАЯ ТЕМА */
  body.dark-theme & {
    border: 1px solid #38c838ff;
    color: #38c838ff;
  }

  &:hover {
    transform: translateY(-2px);
    text-shadow: 0 0 5px rgba(36, 106, 50, 0.5);
    background: rgba(36, 106, 50, 0.05);
    color: #151417;
  }

  /* ДАРК ТЕМА ХОВЕР */
  body.dark-theme &:hover {
    text-shadow: 0 0 5px rgba(56, 200, 56, 0.5);
    background: rgba(56, 200, 56, 0.1);
    color: var(--color-text);
  }
`;

function ProjectCard({ project, isDark }) {
  const [isHovered, setIsHovered] = useState(false);
  const iconSrc = isDark && project.iconDark ? project.iconDark : project.icon;

  return (
    <Card
      $isHovered={isHovered}
      $backImage={project.back}
      $title={project.titleAttribute}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <img src={iconSrc} alt={`${project.name} icon`} />
      <Name>{project.name}</Name>
      <Description dangerouslySetInnerHTML={{ __html: project.description }} />
      <Link href={project.link} target="_blank" rel="noopener noreferrer">
        {project.buttonLabel || "View Project"}
      </Link>
    </Card>
  );
}

export default function Projects() {
  const { theme } = useTheme();
  const isDark = theme === "dark";
  return (
    <SectionProjects id="projects">
      <MaxWidthWrapper>
        <Title>Проекты</Title>
        <CardContainer>
          {projects.map((project, index) => (
            <ProjectCard key={index} project={project} isDark={isDark} />
          ))}
        </CardContainer>
      </MaxWidthWrapper>
    </SectionProjects>
  );
}
